// Mock data para MIT Instituto de Formación Digital

export const careers = [
  {
    id: 'administracion',
    name: 'Administración de Empresas',
    category: 'Administración',
    duration: '3 años',
    modality: 'Semi-Presencial / Virtual',
    image: 'https://customer-assets.emergentagent.com/job_mit-formacion/artifacts/xcbnwj80_WhatsApp%20Image%202026-01-30%20at%204.06.23%20PM%20%281%29.jpeg',
    shortDescription: 'Desarrolla competencias en gestión empresarial y liderazgo',
    description: 'La carrera de Administración de Empresas te capacita para gestionar organizaciones de manera eficiente, desarrollando habilidades en planificación, organización, dirección y control de recursos empresariales.',
    profile: 'Profesional técnico capacitado para administrar y gestionar empresas, con conocimientos en gestión de recursos humanos, finanzas, marketing y operaciones.',
    fieldOfWork: [
      'Empresas privadas (áreas administrativas)',
      'Instituciones públicas',
      'Emprendimiento y gestión de negocios propios',
      'Consultoría empresarial',
      'Organizaciones sin fines de lucro',
      'Áreas de recursos humanos y finanzas'
    ],
    curriculum: [
      { semester: 1, courses: ['Fundamentos de Administración', 'Matemática Empresarial', 'Economía General', 'Comunicación Empresarial', 'Informática Aplicada'] },
      { semester: 2, courses: ['Administración de Personal', 'Contabilidad General', 'Matemática Financiera', 'Derecho Empresarial', 'Marketing I'] },
      { semester: 3, courses: ['Gestión de Recursos Humanos', 'Contabilidad de Costos', 'Estadística Aplicada', 'Marketing II', 'Comportamiento Organizacional'] },
      { semester: 4, courses: ['Finanzas Empresariales', 'Gestión de Operaciones', 'Planeamiento Estratégico', 'Gestión de Proyectos', 'Ética Empresarial'] },
      { semester: 5, courses: ['Gestión de la Calidad', 'Comercio Internacional', 'Gestión de Negocios', 'Emprendimiento', 'Prácticas Pre-Profesionales I'] },
      { semester: 6, courses: ['Dirección Empresarial', 'Gestión del Cambio', 'Responsabilidad Social', 'Prácticas Pre-Profesionales II', 'Seminario de Titulación'] }
    ],
    requirements: [
      'Certificado de estudios secundarios',
      'Habilidades de liderazgo',
      'Capacidad analítica',
      'Orientación a resultados'
    ],
    convalidationAvailable: true
  },
  {
    id: 'contabilidad',
    name: 'Contabilidad',
    category: 'Administración',
    duration: '3 años',
    modality: 'Semi-Presencial / Virtual',
    image: 'https://images.unsplash.com/photo-1554224155-6726b3ff858f',
    shortDescription: 'Conviértete en experto en gestión contable y financiera',
    description: 'La carrera de Contabilidad te forma como profesional técnico capaz de registrar, analizar e interpretar la información financiera de las organizaciones, aplicando normas contables vigentes.',
    profile: 'Profesional técnico especializado en el registro, análisis y presentación de información contable y financiera, con dominio de normativas tributarias y herramientas contables.',
    fieldOfWork: [
      'Departamentos de contabilidad de empresas',
      'Estudios contables',
      'Asesoría tributaria',
      'Auditoría interna',
      'Área de finanzas',
      'Emprendimiento en servicios contables'
    ],
    curriculum: [
      { semester: 1, courses: ['Fundamentos de Contabilidad', 'Matemática Financiera I', 'Introducción a la Economía', 'Ofimática', 'Comunicación'] },
      { semester: 2, courses: ['Contabilidad General', 'Matemática Financiera II', 'Derecho Empresarial', 'Estadística', 'Costos y Presupuestos I'] },
      { semester: 3, courses: ['Contabilidad Intermedia', 'Tributación I', 'Costos y Presupuestos II', 'Sistema Contable Computarizado I', 'Análisis Financiero I'] },
      { semester: 4, courses: ['Contabilidad Superior', 'Tributación II', 'Sistema Contable Computarizado II', 'Análisis Financiero II', 'Auditoría I'] },
      { semester: 5, courses: ['Contabilidad de Sociedades', 'Tributación III', 'Auditoría II', 'Finanzas Empresariales', 'Prácticas Pre-Profesionales I'] },
      { semester: 6, courses: ['Contabilidad Gubernamental', 'Peritaje Contable', 'Gestión Financiera', 'Prácticas Pre-Profesionales II', 'Seminario de Titulación'] }
    ],
    requirements: [
      'Certificado de estudios secundarios',
      'Habilidad numérica',
      'Atención al detalle',
      'Responsabilidad y ética profesional'
    ],
    convalidationAvailable: true
  },
  {
    id: 'mercadotecnia',
    name: 'Mercadotecnia',
    category: 'Administración',
    duration: '3 años',
    modality: 'Semi-Presencial / Virtual',
    image: 'https://images.unsplash.com/photo-1557804506-669a67965ba0',
    shortDescription: 'Especialízate en estrategias de marketing y ventas',
    description: 'La carrera de Mercadotecnia te prepara para diseñar e implementar estrategias de marketing efectivas, gestionar marcas, analizar el comportamiento del consumidor y desarrollar campañas publicitarias exitosas.',
    profile: 'Profesional técnico capacitado para desarrollar estrategias de marketing, gestionar campañas publicitarias, analizar mercados y promover productos o servicios de manera efectiva.',
    fieldOfWork: [
      'Departamentos de marketing de empresas',
      'Agencias de publicidad',
      'Gestión de redes sociales y marketing digital',
      'Investigación de mercados',
      'Ventas y gestión comercial',
      'Emprendimiento en marketing'
    ],
    curriculum: [
      { semester: 1, courses: ['Fundamentos de Marketing', 'Comportamiento del Consumidor', 'Comunicación Publicitaria', 'Matemática Aplicada', 'Ofimática'] },
      { semester: 2, courses: ['Marketing Estratégico', 'Investigación de Mercados I', 'Publicidad y Promoción', 'Ventas y Negociación', 'Diseño Gráfico Básico'] },
      { semester: 3, courses: ['Marketing Digital I', 'Investigación de Mercados II', 'Gestión de Marca', 'Marketing de Servicios', 'Estadística Aplicada'] },
      { semester: 4, courses: ['Marketing Digital II', 'Redes Sociales y Community Management', 'Estrategias de Precio', 'Trade Marketing', 'Fotografía y Video'] },
      { semester: 5, courses: ['E-commerce', 'Analítica Web', 'Relaciones Públicas', 'Gestión de Eventos', 'Prácticas Pre-Profesionales I'] },
      { semester: 6, courses: ['Plan de Marketing', 'Marketing Internacional', 'Emprendimiento', 'Prácticas Pre-Profesionales II', 'Seminario de Titulación'] }
    ],
    requirements: [
      'Certificado de estudios secundarios',
      'Creatividad e innovación',
      'Habilidades de comunicación',
      'Orientación al cliente'
    ],
    convalidationAvailable: true
  },
  {
    id: 'enfermeria',
    name: 'Enfermería Técnica',
    category: 'Salud',
    duration: '3 años',
    modality: 'Presencial',
    image: 'https://images.pexels.com/photos/32213307/pexels-photo-32213307.jpeg',
    shortDescription: 'Fórmate como profesional técnico en el cuidado y atención de la salud',
    description: 'La carrera de Enfermería Técnica te prepara para brindar cuidados de calidad en diversos establecimientos de salud, aplicando conocimientos científicos y técnicos con ética profesional.',
    profile: 'Profesional técnico capacitado para brindar cuidados de enfermería con calidad, calidez y ética profesional en los diferentes niveles de atención de salud.',
    fieldOfWork: [
      'Hospitales públicos y privados',
      'Centros de salud',
      'Clínicas especializadas',
      'Consultorios médicos',
      'Empresas (área de salud ocupacional)',
      'Centros geriátricos'
    ],
    curriculum: [
      { semester: 1, courses: ['Anatomía y Fisiología I', 'Fundamentos de Enfermería', 'Salud Pública I', 'Comunicación', 'Matemática Básica'] },
      { semester: 2, courses: ['Anatomía y Fisiología II', 'Enfermería Básica', 'Salud Pública II', 'Microbiología', 'Farmacología I'] },
      { semester: 3, courses: ['Enfermería en Salud del Adulto I', 'Enfermería Materno Infantil I', 'Farmacología II', 'Nutrición y Dietética', 'Primeros Auxilios'] },
      { semester: 4, courses: ['Enfermería en Salud del Adulto II', 'Enfermería Materno Infantil II', 'Enfermería en Salud Mental', 'Administración en Salud', 'Ética Profesional'] },
      { semester: 5, courses: ['Enfermería en Emergencias', 'Enfermería Comunitaria', 'Investigación en Salud', 'Prácticas Pre-Profesionales I'] },
      { semester: 6, courses: ['Enfermería Especializada', 'Gestión del Cuidado', 'Prácticas Pre-Profesionales II', 'Seminario de Titulación'] }
    ],
    requirements: [
      'Certificado de estudios secundarios',
      'Vocación de servicio',
      'Aptitudes para el cuidado de personas',
      'Responsabilidad y ética'
    ],
    convalidationAvailable: true
  },
  {
    id: 'explotacion-minera',
    name: 'Explotación Minera',
    category: 'Minería',
    duration: '3 años',
    modality: 'Presencial',
    image: 'https://images.pexels.com/photos/35082119/pexels-photo-35082119.jpeg',
    shortDescription: 'Especialízate en operaciones mineras y manejo de equipos pesados',
    description: 'La carrera de Explotación Minera te capacita en las técnicas y procedimientos para la extracción de minerales, operación de maquinaria pesada y supervisión de operaciones mineras con seguridad y eficiencia.',
    profile: 'Técnico profesional capacitado para planificar, ejecutar y supervisar operaciones de explotación minera, aplicando normas de seguridad, medio ambiente y optimización de recursos.',
    fieldOfWork: [
      'Empresas mineras (subterráneas y a tajo abierto)',
      'Contratistas mineros',
      'Empresas de exploración',
      'Consultoría en minería',
      'Supervisión de operaciones',
      'Operación de equipos pesados'
    ],
    curriculum: [
      { semester: 1, courses: ['Matemática Aplicada', 'Física Aplicada', 'Química General', 'Dibujo Técnico Minero', 'Geología General'] },
      { semester: 2, courses: ['Topografía Minera I', 'Geología Estructural', 'Mineralogía', 'Maquinaria Minera I', 'Seguridad Minera I'] },
      { semester: 3, courses: ['Topografía Minera II', 'Explotación Subterránea I', 'Maquinaria Minera II', 'Seguridad Minera II', 'Perforación y Voladura I'] },
      { semester: 4, courses: ['Explotación Subterránea II', 'Explotación a Tajo Abierto', 'Perforación y Voladura II', 'Ventilación de Minas', 'Legislación Minera'] },
      { semester: 5, courses: ['Geomecánica', 'Procesamiento de Minerales', 'Costos y Presupuestos Mineros', 'Medio Ambiente Minero', 'Prácticas Pre-Profesionales I'] },
      { semester: 6, courses: ['Planeamiento Minero', 'Supervisión de Operaciones', 'Gestión de Seguridad', 'Prácticas Pre-Profesionales II', 'Proyecto de Titulación'] }
    ],
    requirements: [
      'Certificado de estudios secundarios',
      'Aptitud física',
      'Habilidad para trabajo en equipo',
      'Disposición para trabajo en altura'
    ],
    convalidationAvailable: true
  },
  {
    id: 'computacion',
    name: 'Computación e Informática',
    category: 'Tecnología',
    duration: '3 años',
    modality: 'Presencial',
    image: 'https://images.unsplash.com/photo-1517694712202-14dd9538aa97',
    shortDescription: 'Domina el desarrollo de sistemas y soluciones tecnológicas',
    convalidationAvailable: true
  },
  {
    id: 'secretariado',
    name: 'Secretariado Ejecutivo',
    category: 'Administración',
    duration: '3 años',
    modality: 'Presencial',
    image: 'https://images.unsplash.com/photo-1573497019940-1c28c88b4f3e',
    shortDescription: 'Asistencia ejecutiva de alto nivel y gestión administrativa',
    convalidationAvailable: true
  }
];

export const testimonials = [
  {
    id: 1,
    name: 'María González',
    career: 'Enfermería Técnica',
    image: 'https://images.pexels.com/photos/30350459/pexels-photo-30350459.jpeg',
    text: 'Trabajaba como auxiliar de enfermería hace 8 años. Gracias a MIT pude convalidr mi experiencia y ahora tengo mi título técnico oficial. ¡Un sueño hecho realidad!',
    type: 'convalidtion'
  },
  {
    id: 2,
    name: 'Carlos Quispe',
    career: 'Explotación Minera',
    image: 'https://images.pexels.com/photos/31290552/pexels-photo-31290552.jpeg',
    text: 'Llevo 10 años trabajando en la mina, pero sin título no podía avanzar. MIT me ayudó a validar mi experiencia y ahora soy supervisor. Totalmente recomendado.',
    type: 'convalidtion'
  },
  {
    id: 3,
    name: 'Ana Huamán',
    career: 'Computación e Informática',
    image: 'https://images.unsplash.com/photo-1494790108377-be9c29b29330',
    text: 'Estudié en MIT y conseguí trabajo antes de titularme. La formación práctica y el apoyo de los docentes fue clave para mi desarrollo profesional.',
    type: 'student'
  },
  {
    id: 4,
    name: 'Pedro Mamani',
    career: 'Administración de Empresas',
    image: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d',
    text: 'La modalidad semi-presencial me permitió estudiar mientras trabajaba. Ahora gestiono mi propio negocio con todo el conocimiento adquirido.',
    type: 'student'
  }
];

export const blogPosts = [
  {
    id: 1,
    title: '¿Por qué es importante contar con un título técnico profesional?',
    excerpt: 'Descubre cómo un título técnico a nombre de la nación puede transformar tu carrera profesional y abrir nuevas oportunidades laborales.',
    image: 'https://images.unsplash.com/photo-1523240795612-9a054b0db644',
    date: '2025-01-15',
    category: 'Orientación Laboral',
    author: 'MIT Formación'
  },
  {
    id: 2,
    title: 'Convalidción: valida tu experiencia laboral en menos tiempo',
    excerpt: 'Si tienes años de experiencia trabajando, puedes obtener tu título técnico oficial sin iniciar desde cero. Te explicamos cómo.',
    image: 'https://images.unsplash.com/photo-1552664730-d307ca884978',
    date: '2025-01-10',
    category: 'Convalidción',
    author: 'MIT Formación'
  },
  {
    id: 3,
    title: 'Enfermería Técnica: una carrera con alta demanda laboral',
    excerpt: 'El sector salud necesita más profesionales técnicos calificados. Conoce las oportunidades que te ofrece esta noble profesión.',
    image: 'https://images.pexels.com/photos/35645530/pexels-photo-35645530.jpeg',
    date: '2025-01-05',
    category: 'Carreras',
    author: 'MIT Formación'
  },
  {
    id: 4,
    title: 'El sector minero en Perú: oportunidades para técnicos especializados',
    excerpt: 'La industria minera peruana demanda técnicos calificados. Descubre por qué Explotación Minera es una carrera estratégica.',
    image: 'https://images.pexels.com/photos/3807517/pexels-photo-3807517.jpeg',
    date: '2024-12-28',
    category: 'Carreras',
    author: 'MIT Formación'
  }
];

export const whyMIT = [
  {
    icon: 'Award',
    title: 'Título Oficial',
    description: 'Título técnico profesional a nombre de la nación con validez oficial y reconocimiento nacional.'
  },
  {
    icon: 'Briefcase',
    title: 'Enfoque Práctico',
    description: 'Formación técnica orientada al mercado laboral con prácticas en empresas del sector.'
  },
  {
    icon: 'Users',
    title: 'Docentes Experimentados',
    description: 'Profesionales con amplia experiencia laboral que comparten conocimiento real y actualizado.'
  },
  {
    icon: 'TrendingUp',
    title: 'Alta Empleabilidad',
    description: 'Nuestros egresados se insertan rápidamente al mercado laboral gracias a su formación integral.'
  },
  {
    icon: 'MapPin',
    title: 'Arraigo Regional',
    description: 'Institución comprometida con el desarrollo de Arequipa y el sur del Perú.'
  },
  {
    icon: 'Clock',
    title: 'Flexibilidad Horaria',
    description: 'Modalidades presencial y semi-presencial que se adaptan a tus necesidades laborales.'
  }
];

export const convalidationSteps = [
  {
    step: 1,
    title: 'Evaluación',
    description: 'Presentas tu documentación laboral y certificados de trabajo. Evaluamos tu experiencia.'
  },
  {
    step: 2,
    title: 'Validación',
    description: 'Realizas evaluaciones técnicas que demuestran tus conocimientos adquiridos en el campo laboral.'
  },
  {
    step: 3,
    title: 'Titulación',
    description: 'Una vez aprobadas las evaluaciones, obtienes tu título técnico profesional a nombre de la nación.'
  }
];

export const faqs = [
  {
    question: '¿Qué es la convalidción de experiencia laboral?',
    answer: 'Es un proceso que permite validar tu experiencia laboral como parte de tu formación técnica, reduciendo el tiempo necesario para obtener tu título profesional.'
  },
  {
    question: '¿Cuántos años de experiencia necesito para convalidr?',
    answer: 'Generalmente se requieren al menos 3 años de experiencia laboral comprobable en el área de la carrera técnica que deseas obtener.'
  },
  {
    question: '¿El título tiene validez oficial?',
    answer: 'Sí, todos nuestros títulos técnicos profesionales son a nombre de la nación y cuentan con validez oficial en todo el territorio peruano.'
  },
  {
    question: '¿Puedo estudiar y trabajar al mismo tiempo?',
    answer: 'Sí, ofrecemos modalidades presencial y semi-presencial con horarios flexibles diseñados para personas que trabajan.'
  },
  {
    question: '¿Qué documentos necesito para matricularme?',
    answer: 'DNI, certificado de estudios secundarios, 2 fotos tamaño carnet y llenar la ficha de matrícula. Para convalidción, además necesitas certificados de trabajo.'
  },
  {
    question: '¿Cuánto dura la carrera técnica?',
    answer: 'Las carreras técnicas tienen una duración de 3 años (6 semestres académicos). Con convalidción, el tiempo puede reducirse significativamente.'
  }
];